<template>
  <div>
    <div class="header">
      <div class="container-fluid container-boxed">
        <div class="header-body">
          <h6 class="header-pretitle">Overview</h6>
          <h1 class="header-title">Placements</h1>
        </div><!-- / .header-body -->
      </div>
    </div><!-- / .header -->

    <div class="container-fluid container-boxed">
      <p>Select a placement from the list to view the details and access your Performance and Development Plan.</p>

      <div class="row">
        <div class="col-12 col-md-6 col-lg-4">
          <div class="form-group">
            <label class="control-label">Search</label>
            <input type="text" class="form-control" v-model="filters.search" placeholder="Search...">
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4">
          <div class="form-group">
            <label class="control-label">Date From</label>
            <input type="date" class="form-control" v-model="filters.startDate">
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4">
          <div class="form-group">
            <label class="control-label">Date To</label>
            <input type="date" class="form-control" v-model="filters.endDate">
          </div>
        </div>
      </div><!-- /.row -->
      <div class="decorative-divider mt-0"></div>
      <div class="card">
        <ul class="list-data">
          <li class="data-heading d-none d-md-block">
            <div class="row">
              <div class="col">Placement</div>
              <div class="col-auto text-right">Placement Dates</div>
            </div><!-- /.row -->
          </li>
          <placements-list-item v-for="placement in placements" :placement="placement" :key="placement.id"/>
        </ul><!-- /.list-data -->
      </div><!-- /.card -->
      <div class="decorative-divider mt-0"></div>
        <div class="card">
          <ul class="list-data no-hover has-button">
            <li class="data-heading d-none d-md-block">
              <router-link :to="{ name: 'graduates.assessments.single', params: { graduateId: graduate.id }}" class="p-0">
              <div class="row align-items-center">
                <div class="col">
                  Overall Performance Assessment
                </div>

                <div class="col-auto">
                  {{ currentPlacement.agency.name }}
                </div>

                <div class="col-auto">
                  {{ graduate.assessment.open_date ? formatDate(graduate.assessment.open_date) : '' }}
                  to
                  {{ graduate.assessment.due_date ? formatDate(graduate.assessment.due_date) : '' }}
                </div>
              </div>
              </router-link>
            </li>
          </ul>
        </div>
    </div><!-- /.container-fluid -->
  </div>
</template>

<script>
import { appliesFilters } from 'mixins'
import { helpers } from 'mixins/graduates'
import PlacementsListItem from './PlacementsListItem'
import { placementMethods, placementComputed, authComputed, graduateComputed, graduateMethods } from 'vx/helpers'

export default {
  mixins: [appliesFilters, helpers],

  components: {
    PlacementsListItem
  },
  watch: {
    queryParams: {
      async handler (params) {
        this.fetching = true
        await this.getPlacements({ ...params })

        this.fetching = false
      }
    }
  },

  data () {
    return {
      filters: {
        search: '',
        startDate: '',
        endDate: ''
      }
    }
  },

  computed: {
    ...placementComputed,
    ...authComputed,
    ...graduateComputed
  },

  async created () {
    await this.getPlacements()
    await this.getGraduate(this.user.id)
  },

  methods: {
    ...placementMethods,
    ...graduateMethods,

    formatDate (date) {
      return new Date(date).toLocaleDateString('en-GB')
    }
  }
}
</script>
